import { render, staticRenderFns } from "./SelfRegFeeEdit.vue?vue&type=template&id=eb4f4ee0&scoped=true&"
import script from "./SelfRegFeeEdit.vue?vue&type=script&lang=js&"
export * from "./SelfRegFeeEdit.vue?vue&type=script&lang=js&"
import style0 from "./SelfRegFeeEdit.vue?vue&type=style&index=0&id=eb4f4ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4f4ee0",
  null
  
)

export default component.exports